import Num2persian from 'num2persian'
/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
function find (list, f) {
  return list.filter(f)[0]
}

/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */
export function deepCopy (obj, cache = []) {
  // just return if obj is immutable value
  if (obj === null || typeof obj !== 'object') {
    return obj
  }

  // if obj is hit, it is in circular structure
  const hit = find(cache, c => c.original === obj)
  if (hit) {
    return hit.copy
  }

  const copy = Array.isArray(obj) ? [] : {}
  // put the copy into cache at first
  // because we want to refer it in recursive deepCopy
  cache.push({
    original: obj,
    copy
  })

  Object.keys(obj).forEach(key => {
    copy[key] = deepCopy(obj[key], cache)
  })

  return copy
}
export function convertNumbers2English(str) {
  if (!str) return null
  return str.replace(/[\u0660-\u0669\u06f0-\u06f9]/g, function(c) {
    return c.charCodeAt(0) & 0xf
  })
}

export function numToPersian(amount) {
  return Num2persian(amount)
}
/**
 * forEach for object
 */
export function forEachValue (obj, fn) {
  Object.keys(obj).forEach(key => fn(obj[key], key))
}

export function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

export function isPromise (val) {
  return val && typeof val.then === 'function'
}

export function assert (condition, msg) {
  if (!condition) throw new Error(`[vuex] ${msg}`)
}

export function serialize (obj) {
  return Object.keys(obj).reduce(function (a, k) {
    let val = obj[k]
    if (val !== null && typeof val === 'object') {
      val = JSON.stringify(val)
    }
    a.push(k + '=' + encodeURIComponent(val))
    return a
  }, []).join('&')
}

export const permissionHaveNameSpace = (permissions) => {
  let allowed = false
  if (!Array.isArray(permissions)) {
    allowed = true
  } else {
    let currentRole = localStorage.getItem('ClientTypeID')
    let find = permissions.filter(item => item === +currentRole)
    if (find.length) {
      allowed = true
    } else {
      allowed = false
    }
  }
  return allowed
}
